import React from 'react';
import { Box } from '@mui/material';
import PhoneFrame from './PhoneFrame';
import NotificationCard from './NotificationCard';
import { COLORS } from './tokens';

/**
 * Phone showing a push notification on the lock screen — the live preview of
 * the composer on D04 (desktop).
 */
export default function PhoneWithPush({ scale = 1, storeName, title, text, logoUrl, primaryColor = COLORS.green, pulse = false, sx = {} }) {
    return (
        <PhoneFrame scale={scale} showStatusBar={false} sx={sx}>
            <Box
                sx={{
                    width: '100%',
                    height: '100%',
                    background: 'linear-gradient(165deg, #1a2332 0%, #0f1825 100%)',
                    position: 'relative',
                    overflow: 'hidden'
                }}
            >
                <Box sx={{ textAlign: 'center', color: '#fff', pt: 3, fontWeight: 200, fontSize: 56, lineHeight: 1, letterSpacing: '-2px' }}>
                    9:41
                </Box>
                <Box sx={{ textAlign: 'center', color: '#fff', fontSize: 15, mt: 0.75, opacity: 0.85 }}>
                    sexta-feira, 12 de junho
                </Box>

                <NotificationCard
                    storeName={storeName}
                    title={title}
                    text={text}
                    logoUrl={logoUrl}
                    primaryColor={primaryColor}
                    pulse={pulse}
                    sx={{ position: 'absolute', left: 12, right: 12, top: 200 }}
                />
            </Box>
        </PhoneFrame>
    );
}
